import type { RouteObject } from 'react-router';

export const vendorRequestsRoutes: RouteObject = {
  path: '/applications/vendor-requests',
  lazy: async () => {
    const { default: Component } = await import('src/pages/VendorRequests');
    return { Component };
  },
};
